import React, { useId, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { metricPresentation, MetricPresentationInput } from './metricPresentation';

export default function MetricVerification({ metric, compact = false }: { metric: MetricPresentationInput; compact?: boolean }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const presentation = metricPresentation(metric);
  if (!presentation.unverified) return null;

  return <>
    <Button size="small" variant="outlined" startIcon={<HelpOutline sx={{ fontSize: '17px !important' }} />}
      aria-label={`About ${presentation.label}: Unverified metric`} aria-haspopup="dialog" aria-expanded={open}
      onClick={() => setOpen(true)}
      sx={{ minHeight: compact ? 22 : 30, px: compact ? .5 : 1, py: compact ? 0 : .25, borderRadius: '8px', fontSize: compact ? 10 : 11, fontWeight: 600,
        textTransform: 'none', color: '#805511', borderColor: '#e3cea5', bgcolor: '#fff9ed',
        '&:hover': { borderColor: '#b28332', bgcolor: '#fff2d8' },
        '&.Mui-focusVisible': { outline: '3px solid #b28332', outlineOffset: 2 } }}>
      Unverified metric
    </Button>
    <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}
      fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle id={`${id}-title`}>Unverified metric</DialogTitle>
      <DialogContent>
        <Typography fontWeight={600} sx={{ mb: 1 }}>{presentation.label}</Typography>
        <DialogContentText id={`${id}-description`}>
          This metric has not been verified by StudySyncs. Data may be unavailable or vary by participant.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button autoFocus onClick={() => setOpen(false)}>Got it</Button>
      </DialogActions>
    </Dialog>
  </>;
}
